import { Directive, computed, input } from '@angular/core';

export type ListLinkGroupGap = 'none' | 'tight' | 'normal';

@Directive({
  selector: '[grooveListLinkGroup]',
  standalone: true,
  host: {
    class: 'groove-list-link-group',
    '[style.--_list-link-group-gap]': 'gapVar()',
  },
})
export class GrooveListLinkGroupDirective {
  readonly gap = input<ListLinkGroupGap>('none');

  protected readonly gapVar = computed(() => {
    switch (this.gap()) {
      case 'tight':
        return 'var(--groove-space-100)';
      case 'normal':
        return 'var(--groove-space-300)';
      default:
        return null;
    }
  });
}
